// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"cffabcdb","908":"110fece0","992":"3ea80c4b"}[chunkId] + ".chunk.js";
};